<script setup lang="ts">
import ArticlePublicPage from '~/components/Article/ArticlePublicPage.vue';
import { IaPageAudience } from '~/composables/unified/useIaAudience';

definePageMeta({
  authType: [AUTH_ROUTE_TYPE_NONE],
  name: 'career-advice-article-slug',
  layout: 'unified-public',
  // A signed-in student under the new information architecture reads it inside the coach shell.
  ia: { audience: IaPageAudience.All, on: '/coach/career-advice/:considerationAreaSlug/:articleSlug', fullWidth: true },
  iaBack: true,
});
</script>

<template>
  <ArticlePublicPage />
</template>
